import React, { Component, createContext } from "react";
import { isEqual } from 'lodash';

// Requests
import { getProjectsRequest } from "api/project";

const ProjectContext = createContext();
export class ProjectProvider extends Component {
    state = {
        selectedProject: '',
        loadedProjects: []
    }


    async componentDidMount() {
        let localStorageData = JSON.parse(localStorage.getItem('selectedProject'));        
        let projects = [];
        
        if(!localStorageData) {
            const getReturn = await getProjectsRequest({});
            projects = getReturn.projects
        }
        
        if (projects?.length > 0) {
            this.setState({
               selectedProject: projects[0]?._id
            })
        } else {
            this.setState({
                selectedProject: localStorageData.selectedProject
             }) 
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedProject } = this.state
    
        if(!isEqual(prevState.selectedProject, selectedProject)) {
			localStorage.setItem('selectedProject', JSON.stringify({selectedProject}));
		}
    }

    handleSelectProject = (project) => {
        this.setState({
            selectedProject: project.value
        })
    }
    
    loadContextProjects = async (filters={}) => {
        const { projects } = await getProjectsRequest(filters);

        this.setState({
            loadedProjects: projects
        })

        return projects
	}

    render () {
        const { selectedProject, loadedProjects } = this.state;
        const { handleSelectProject, loadContextProjects } = this;

        return (
            <ProjectContext.Provider value={{ 
                // Variabless
                selectedProject,
                loadedProjects,
                // Functions
                handleSelectProject,
                loadContextProjects 
            }}>
                {this.props.children}
            </ProjectContext.Provider>
        )
    }
}

export default ProjectContext;